import { text0, text1, bgPrimary } from '@osmosis/tailwind-ui/styles';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import React from 'react';
import Image from 'next/image';
import { FormattedMessage } from 'react-intl';
import { CLOUDFRONT_ASSET_URL } from '@osmosis/constants';
import { Box, Flex } from '@osmosis/tailwind-ui/components/Box';
import { P, H1 } from '@osmosis/tailwind-ui/components/Text';
import TrialCTA from '../TrialCTA';
import type { TrialCtaArgs } from '../../lib/composer/schemas/answersValueProp';

/**
 * AnswersHeader.
 */
export const AnswersHeader = ({ trialCta }: { trialCta?: TrialCtaArgs }) => {
  return (
    <Flex data-testid="answers-banner" className={cn('w-full p-5', bgPrimary)}>
      <Flex
        data-testid="answers-wrapper"
        className="max-w-5xl mx-auto flex justify-between w-full"
      >
        <Flex
          data-testid="answers-banner-info"
          className="w-answers-info md:w-answers-info-md flex flex-col justify-between"
        >
          <H1 data-testid="answers-banner-title" className={cn('mb-4', text0)}>
            <FormattedMessage
              id="answers.heading.descr"
              defaultMessage="Osmosis Question and Answer Topics"
            />
          </H1>

          <P
            data-testid="answers-banner-description"
            className={cn('mb-4 max-w-answers-description', text0)}
          >
            <FormattedMessage
              id="answers.heading.descr.new"
              defaultMessage="Osmosis turns even the toughest topics into clear, illustrated videos so you can learn rather than memorize."
            />
          </P>

          <Box data-testid="answers-banner-button-container" className="w-auto">
            <TrialCTA
              copy={trialCta}
              containerTestId="answers-banner-trial-cta"
              buttonTestId="answers-banner-link"
              fineprintTestId="answers-banner-trial-cta-fineprint"
              classNames={{
                container: 'p-0',
                fineprint: `${text1} text-base`,
              }}
            />
          </Box>
        </Flex>

        <Box className="pl-4 pr-4 md:block lg:flex flex-col justify-center">
          <Image
            data-testid="answers-banner-image"
            alt="Book"
            width={200}
            height={150}
            src={`${CLOUDFRONT_ASSET_URL}hunKHm0gRVOX_noBu6I-Occ-TiCkw79p.png`}
          />
        </Box>
      </Flex>
    </Flex>
  );
};

export default AnswersHeader;
